import { getApiClient } from './client'

import type { CountryItem, CountrySubdivisionItem, CurrencyItem, GeoInfoResponse } from './types'

export async function getGeoInfo() {
  return getApiClient().get<GeoInfoResponse>('/api/v1/geo/country')
}

export async function getCurrencyList(productCode: string) {
  return getApiClient().get<CurrencyItem[]>(
    `/api/v1/currencies?product_code=${encodeURIComponent(productCode)}`
  )
}

export async function getCountryList() {
  return getApiClient().get<CountryItem[]>('/api/v1/geo/countries')
}

export async function getCountrySubdivisionList(countryCode: string) {
  return getApiClient().get<CountrySubdivisionItem[]>(
    `/api/v1/geo/countries/${encodeURIComponent(countryCode)}/subdivisions`
  )
}
